import * as React from 'react'
import styled from 'styled-components'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import LazyLoad from 'react-lazyload'
import { Skeleton } from '@material-ui/lab'
import WebpImg from 'components/Image/WebpImg'

export default function Index({ src = '', square = false }) {
  return (
    <div>{square ? <SquareImage src={src} /> : <FullImage src={src} />}</div>
  )
}

const SquareImage = ({ src }) => {
  const SquareWebpImg = styled(WebpImg)`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    position: absolute;
  `

  const SquareFrame = styled.div`
    width: 100%;
    padding-bottom: 100%;
    position: relative;
  `

  return (
    <SquareFrame>
      <LazyLoad placeholder={<Skeleton variant="rect" height={200} />}>
        <TransitionGroup>
          <CSSTransition
            classNames="fade"
            appear
            timeout={{ appear: 500 }}
            enter={false}
            leave={false}
          >
            <SquareWebpImg imgSrc={src} />
          </CSSTransition>
        </TransitionGroup>
      </LazyLoad>
    </SquareFrame>
  )
}

const FullImage = ({ src }) => {
  return (
    <div style={{ minHeight: 200 }}>
      <LazyLoad placeholder={<Skeleton variant="rect" height={200} />}>
        <TransitionGroup>
          <CSSTransition
            classNames="fade"
            appear
            timeout={{ appear: 300 }}
            enter={false}
            leave={false}
          >
            <FullWebpImg imgSrc={src} />
          </CSSTransition>
        </TransitionGroup>
      </LazyLoad>
    </div>
  )
}

const FullWebpImg = styled(WebpImg)`
  width: 100%;
`
